export default __webpack_public_path__ + "static/media/keto_flu@2x.6bc07c09.jpg";